import { createApp } from 'vue'
import FlashMessages from '@services/FlashMessages'
import axios from 'axios'
import iframeResize from 'iframe-resizer/js/iframeResizer'

import IssuePane from '@components/issues/IssuePane'
import IssueIframe from '@components/issues/IssueIframe'

import i18n from '@utils/i18n'

import TurbolinksAdapter from 'vue-turbolinks'

export default () => {
  const issuesEl = document.getElementById('issues-vue-app')
  if (issuesEl) {
    const props = {
      data: gon.form_response
    }

    const issuesApp = createApp(IssuePane, props)
    issuesApp.use(i18n)
    issuesApp.use(TurbolinksAdapter)
    issuesApp.mount(issuesEl)
  }

  const issuesFrameEl = document.getElementById('issues-iframe-vue-app')
  if (issuesFrameEl) {
    const props = {
      data: gon.iframe_form_response
    }

    const issuesFrameApp = createApp(IssueIframe, props)
    issuesFrameApp.use(i18n)
    issuesFrameApp.use(TurbolinksAdapter)
    issuesFrameApp.directive('resize', {
      bind: function(el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
      },
      unbind: function (el) {
        el.iFrameResizer.removeListeners();
      }
    })

    issuesFrameApp.mount(issuesFrameEl)
  }

  // Issues index page
  let countrySelectElem = document.getElementById("country-selector-elem")
  let trainingCenterGroupSelectElem = document.getElementById("training-center-group-selector-elem")

  if (countrySelectElem && countrySelectElem) {
    countrySelectElem.addEventListener("change", function (e) {
      if (e.target.value) {
        fetchTcgsForCountry(e.target.value)
          .then(resp => {
            clearOptions(trainingCenterGroupSelectElem)
            
            let emptyPlaceholder = document.createElement("option")
            trainingCenterGroupSelectElem.append(emptyPlaceholder)
    
            resp.data.forEach(tcg => {
              let newElem = document.createElement("option")
              newElem.innerText = tcg.name
              newElem.value = tcg.id
              trainingCenterGroupSelectElem.append(newElem);
            })
          })
      }

    })
  }

  // TODO: what is this warning....Strict-Transport-Security: The connection to the site is untrustworthy, so the specified header was ignored. 
  function fetchTcgsForCountry(country_id) {
    return axios.get(`/training_center_groups.json`, {
      params: {
        country_id: country_id,
        state: 'active'
      }
    }, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    })
  }

  function clearOptions (elem) {
    var i, L = elem.options.length - 1;
    for(i = L; i >= 0; i--) {
      elem.remove(i);
    }
  }

  let setDefaultDepartment = document.getElementById("set-default-department")
  if (setDefaultDepartment){
    setDefaultDepartment.addEventListener("click", function (e) {
      let userId = window.gon.current_user.id
      let currentDepartment = e.target.dataset.currentDepartment
      console.log(currentDepartment)
      return axios.patch(`/users/${userId}/update_setting`, {
        type: 'issue_default_department',
        value: currentDepartment
      }, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
      })
      .then(response => {
        FlashMessages.success('user default department successfully updated.')
        this.isSavingAssociation = false
        this.associationChangePending = false
        return response
      }, error => {
        FlashMessages.success('We experienced an error updating default.')
        //this.$rollbar('error updating user default department for Issues', { error: error })
        console.log('error', error)
      })

    })
  }
  
}

